import React, { useMemo } from 'react';

import { CareerCmsContent } from './career-content';
import { unwrapCareerCmsRecordFromPageQuery } from './cms-provider/career-cms-provider';
import { GlobalContentProvider } from './global-content-provider';

type CareerContentProviderProps = {
  children: React.ReactNode;
  globalAndCareerCmsPageData: unknown;
};

const CareerContentProvider = ({
  children,
  globalAndCareerCmsPageData,
}: CareerContentProviderProps) => {
  const careerCmsContent = useMemo(
    () => unwrapCareerCmsRecordFromPageQuery(globalAndCareerCmsPageData),
    [globalAndCareerCmsPageData]
  );

  return (
    <GlobalContentProvider globalCmsPageData={globalAndCareerCmsPageData}>
      <CareerCmsContent.Provider value={careerCmsContent}>{children}</CareerCmsContent.Provider>
    </GlobalContentProvider>
  );
};

export default CareerContentProvider;
